import {usePromotion} from '@/context/Promotion/PromotionContext'

const DEFAULT_SEGMENT_GROUP = {selectionType: '', segments: []}

export const useSegmentsOperations = () => {
  const {
    onResultChange: updatePromotion,
    promotion: {segmentConfiguration},
    promotion,
  } = usePromotion()

  const handleAllCustomersToggle = value => {
    const updatedSegmentConfig = {
      ...segmentConfiguration,
      includedSegments: value ? [] : [DEFAULT_SEGMENT_GROUP],
    }
    updatePromotion({segmentConfiguration: updatedSegmentConfig, allCustomers: value})
  }

  const handleExcludeToggle = value => {
    const updatedSegmentConfig = {
      ...segmentConfiguration,
      excludedSegment: value ? DEFAULT_SEGMENT_GROUP : undefined,
    }
    updatePromotion({segmentConfiguration: updatedSegmentConfig})
  }

  const handleAddGroup = () => {
    const updatedSegmentConfig = {
      ...segmentConfiguration,
      includedSegments: [...(segmentConfiguration?.includedSegments || []), DEFAULT_SEGMENT_GROUP],
    }
    updatePromotion({segmentConfiguration: updatedSegmentConfig})
  }

  const handleSubmitSegments = (selectedSegments, groupIndex, type) => {
    if (groupIndex === null) {
      // Updating excluded segments
      const updatedSegmentConfig = {
        ...segmentConfiguration,
        excludedSegment: {
          selectionType: type,
          segments: selectedSegments,
        },
      }
      updatePromotion({segmentConfiguration: updatedSegmentConfig})
    } else {
      // Updating included segments for a specific group
      const updatedIncludedSegments = segmentConfiguration.includedSegments.map((group, index) => {
        if (index === groupIndex) {
          return {
            selectionType: type,
            segments: selectedSegments,
          }
        }
        return group
      })
      const updatedSegmentConfig = {
        ...segmentConfiguration,
        includedSegments: updatedIncludedSegments,
      }
      updatePromotion({segmentConfiguration: updatedSegmentConfig})
    }
  }
  const isAllCustomers = promotion?.allCustomers
  const isExcludeEnabled = segmentConfiguration?.excludedSegment

  return {
    handleAllCustomersToggle,
    handleExcludeToggle,
    handleAddGroup,
    isAllCustomers,
    isExcludeEnabled,
    segmentConfiguration,
    handleSubmitSegments,
  }
}
